import { render, staticRenderFns } from "./ItemDelete.vue?vue&type=template&id=0b4153d2&scoped=true&"
import script from "./ItemDelete.vue?vue&type=script&lang=js&"
export * from "./ItemDelete.vue?vue&type=script&lang=js&"
import style0 from "./ItemDelete.vue?vue&type=style&index=0&id=0b4153d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4153d2",
  null
  
)

export default component.exports